<p-progressBar class="progress-container" [value]="value"></p-progressBar>
